import main from './main';
import track from './track';

export default { main, highway: main, track, location_only: main };
